import React, { useState } from 'react';
import '../MobileHeader/MobileHeader.css';
import { Link } from 'react-router-dom';

import logoimg from '../../Assets/Images/logo.png';
import logoimgs from '../../Assets/Images/IBS-Logo_Full-1-1.png';

const MobileHeader = () => {
    const [isVisible, setIsVisible] = useState(false); // State to track visibility of menu
    const [isSubmenuVisible, setIsSubmenuVisible] = useState(false); // State to track visibility of Marketing submenu
    const [isServicesSubmenuVisible, setIsServicesSubmenuVisible] = useState(false); // State to track visibility of Services submenu
    const [isBlockchainSubmenuVisible, setIsBlockchainSubmenuVisible] = useState(false); // State to track visibility of Blockchain submenu


    // priya
    const [activeMenu, setActiveMenu] = useState(null);
    const [activeSubMenu, setActiveSubMenu] = useState(null);
    const [activeSubMenuItem, setActiveSubMenuItem] = useState(null);

    // priya


    const handlenevToggle = () => {
        setIsVisible(!isVisible); // Toggle the visibility of the menu
    };

    const handleSubmenuToggle = () => {
        if (isSubmenuVisible) {
            setIsSubmenuVisible(false);
        } else {
            setIsSubmenuVisible(true);
            setIsServicesSubmenuVisible(false);
            setIsBlockchainSubmenuVisible(false);
        }
    };

    const handleServicesSubmenuToggle = () => {
        if (isServicesSubmenuVisible) {
            setIsServicesSubmenuVisible(false);
        } else {
            setIsServicesSubmenuVisible(true);
            setIsSubmenuVisible(false);
            setIsBlockchainSubmenuVisible(false);
        }
    };



    const portfolioSubmenuToggle = () => {
        if (isBlockchainSubmenuVisible) {
            setIsBlockchainSubmenuVisible(false);
        } else {
            setIsBlockchainSubmenuVisible(true);
            setIsSubmenuVisible(false);
            setIsServicesSubmenuVisible(false);
        }
    };

    const closeMenu = () => {
        setIsVisible(false); // Close the entire menu
        setIsSubmenuVisible(false);
        setIsServicesSubmenuVisible(false);
        setIsBlockchainSubmenuVisible(false);
    };


    // priya
    const toggleMenu = () => {
        setIsVisible(!isVisible);
        setActiveMenu(null);
        setActiveSubMenu(null);
    };

    const handleMenuClick = (menu) => {
        setActiveMenu(activeMenu === menu ? null : menu);
        setActiveSubMenu(null);
    };

    const handleSubMenuClick = (submenu) => {
        setActiveSubMenu(activeSubMenu === submenu ? null : submenu);
    };




    // const handleItemClick = (itemName) => {
    //     setActiveItem(itemName); 
    // };


    const closeMenu2 = () => {
        setIsVisible(false);
        setActiveMenu(null);
        setActiveSubMenu(null);
    };

    // priya


    // Handle submenu item click
    //   const handleSubMenuItemClick = (subMenuItem, path) => {
    //     setActiveSubMenuItem(subMenuItem);
    //     navigate(path); // Navigate to the page
    //   };



    // end 



    return (

        <div className="mobhdrc">
            {/* Overlay Div */}
            {isVisible && <div className="nevoverly" onClick={handlenevToggle}></div>}

            <section style={{ height: '0vh', marginTop: '0%' }}>
                <div className="nev-container nevigation">
                    <div className="brand">
                        <Link to="">
                            <img src={logoimg} alt="Logo" />
                        </Link>
                    </div>
                    <div
                        className="tabimg1"
                        style={{
                            width: '35%',
                            marginLeft: '19%',
                        }}
                    >
                        <Link to="" className="tabimg">
                            <img src={logoimgs} alt="Tab Logo" />
                        </Link>
                    </div>
                    <div className="nev-mobile" onClick={handlenevToggle}>
                        <Link to="#" id="nevbar-toggle">
                            <span></span>
                        </Link>
                    </div>
                    <div className="bg" style={{ display: isVisible ? 'block' : 'none' }}>
                        <ul className="nev-list anv">
                            <li>
                                <Link
                                    to="/about"
                                    onClick={() => {
                                        closeMenu();
                                        setTimeout(() => {
                                            window.location.reload();
                                        }, 0);
                                    }}
                                >
                                    About
                                </Link>
                            </li>


                            <li>
                                <Link
                                    to="#!"
                                    onClick={() => handleMenuClick('marketing')}
                                    className={`dropmenu ${activeMenu === 'marketing' ? 'active' : ''}`}
                                >
                                    Marketing
                                </Link>
                                {activeMenu === 'marketing' && (
                                    <ul className="navbar-dropdown innerDropdown">
                                        <li>
                                            <Link
                                                to="/marketing/seo"
                                                onClick={() => {
                                                    closeMenu();
                                                    setTimeout(() => {
                                                        window.location.reload();
                                                    }, 0);
                                                }}
                                            >
                                                SEO
                                            </Link>

                                        </li>
                                        <li>
                                            <Link
                                                to="/marketing/blogger-outreach"
                                                onClick={() => {
                                                    closeMenu();
                                                    setTimeout(() => {
                                                        window.location.reload();
                                                    }, 0);
                                                }}
                                            >
                                                Blogger Outreach Services
                                            </Link>

                                        </li>
                                    </ul>
                                )}
                            </li>

                            <li>
                                <Link
                                    to="#!"
                                    onClick={() => handleMenuClick('portfolio')}
                                    className={`dropmenu ${activeMenu === 'portfolio' ? 'active' : ''}`}
                                >
                                    Portfolio
                                </Link>
                                {activeMenu === 'portfolio' && (
                                    <ul className="navbar-dropdown innerDropdown">
                                        <li>
                                            <Link
                                                to="/Mobile-Portfolio"
                                                onClick={() => {
                                                    closeMenu();
                                                    setTimeout(() => {
                                                        window.location.reload();
                                                    }, 0);
                                                }}
                                            >
                                                Mobile Apps
                                            </Link>

                                        </li>
                                        <li>
                                            <Link
                                                to="/web-portfolio"
                                                onClick={() => {
                                                    closeMenu();
                                                    setTimeout(() => {
                                                        window.location.reload();
                                                    }, 0);
                                                }}
                                            >
                                                Website
                                            </Link>

                                        </li>
                                        <li>
                                            <Link
                                                to="/game-portfolio"
                                                onClick={() => {
                                                    closeMenu();
                                                    setTimeout(() => {
                                                        window.location.reload();
                                                    }, 0);
                                                }}
                                            >
                                                Gaming
                                            </Link>

                                        </li>


                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => handleSubMenuClick('products')}
                                                className={`dropmenu ${activeSubMenu === 'products' ? 'active' : ''}`}
                                            >
                                                Our Products
                                            </Link>
                                            {activeSubMenu === 'products' && (
                                                <ul className="navbar-dropdown sub-menu" id="navbarDropdownInner">
                                                    <li><a
                                                        href="https://invoicemint.in/"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Invoicemint
                                                    </a>

                                                    </li>
                                                    <li><a
                                                        href="https://spliter.interestbudsolutions.com/"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Spliter
                                                    </a>

                                                    </li>

                                                </ul>
                                            )}
                                        </li>

                                    </ul>

                                )}
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    onClick={() => handleMenuClick('services')}
                                    className={`dropmenu ${activeMenu === 'services' ? 'active' : ''}`}
                                >
                                    Services
                                </Link>
                                {activeMenu === 'services' && (
                                    <ul className="navbar-dropdown innerDropdown">
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => handleSubMenuClick('nativeApps')}
                                                className={`dropmenu ${activeSubMenu === 'nativeApps' ? 'active' : ''}`}
                                            >
                                                Native Apps
                                            </Link>
                                            {activeSubMenu === 'nativeApps' && (
                                                <ul className="navbar-dropdown sub-menu" id="navbarDropdownInner">
                                                    <li><Link
                                                        to="/services/native-apps/Mobile-development"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Mobile App Development
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/native-apps/ios"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Native IOS Apps
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/android"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Android App Apps
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/wearable"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Wearable App Development
                                                    </Link>
                                                    </li>
                                                </ul>
                                            )}
                                        </li>
                                        <li>
                                            <Link to="#" onClick={() => handleSubMenuClick('crossPlatform')} className={`dropmenu ${activeSubMenu === 'crossPlatform' ? 'active' : ''}`}>Cross Platform</Link>
                                            {activeSubMenu === 'crossPlatform' && (
                                                <ul className="navbar-dropdown sub-menu" id="navbarDropdownInner">
                                                    <li><Link
                                                        to="/services/native-apps/Mobile-development"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Xamarin
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/native-apps/Mobile-development"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        React Native
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/native-apps/Mobile-development"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 50);
                                                        }}
                                                    >
                                                        Flutter App Development
                                                    </Link>
                                                    </li>
                                                </ul>
                                            )}
                                        </li>

                                        <li>
                                            <Link to="#" onClick={() => handleSubMenuClick('gamingApps')} className={`dropmenu ${activeSubMenu === 'gamingApps' ? 'active' : ''}`}>Gaming Apps</Link>
                                            {activeSubMenu === 'gamingApps' && (
                                                <ul className="navbar-dropdown sub-menu" id="navbarDropdownInner">
                                                    <li><Link
                                                        to="/services/unity-gaming"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Unity Engines
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/unity-gaming"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        2D / 3D Games
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/unity-gaming"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        AR / VR Games
                                                    </Link>
                                                    </li>
                                                </ul>
                                            )}
                                        </li>


                                        <li>
                                            <Link to="#" onClick={() => handleSubMenuClick('webApps')} className={`dropmenu ${activeSubMenu === 'webApps' ? 'active' : ''}`}>Web Apps</Link>
                                            {activeSubMenu === 'webApps' && (
                                                <ul className="navbar-dropdown sub-menu" id="navbarDropdownInner">
                                                    <li><Link
                                                        to="/services/website"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Angular
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/website"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        React JS
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/website"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        PHP
                                                    </Link>
                                                    </li>
                                                </ul>
                                            )}
                                        </li>

                                        <li>
                                            <Link to="#" onClick={() => handleSubMenuClick('websiteDevelopment')} className={`dropmenu ${activeSubMenu === 'websiteDevelopment' ? 'active' : ''}`}>Website Apps</Link>
                                            {activeSubMenu === 'websiteDevelopment' && (
                                                <ul className="navbar-dropdown sub-menu" id="navbarDropdownInner">
                                                    <li><Link
                                                        to="/services/website"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        PHP
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/website"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Code Ignitor
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/website"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Laravel
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/website"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Cake PHP
                                                    </Link>
                                                    </li>
                                                </ul>
                                            )}
                                        </li>

                                        <li>
                                            <Link to="#" onClick={() => handleSubMenuClick('Designing')} className={`dropmenu ${activeSubMenu === 'Designing' ? 'active' : ''}`}>Designing</Link>
                                            {activeSubMenu === 'Designing' && (
                                                <ul className="navbar-dropdown sub-menu" id="navbarDropdownInner">
                                                    <li><Link
                                                        to="/services/designing"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        UI / UX
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/designing"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Logo Design
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/designing"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Graphic Design
                                                    </Link>
                                                    </li>
                                                </ul>
                                            )}
                                        </li>


                                        <li>
                                            <Link to="#" onClick={() => handleSubMenuClick('blockchainTokens')} className={`dropmenu ${activeSubMenu === 'blockchainTokens' ? 'active' : ''}`}>Blockchain And Token</Link>
                                            {activeSubMenu === 'blockchainTokens' && (
                                                <ul className="navbar-dropdown sub-menu" id="navbarDropdownInner">
                                                    <li><Link
                                                        to="/services/blockchain-development"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Blockchain Development
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/ALT-coin-development"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Alt Coin Development Service
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/multichain-blockchain-development"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Multichain Blockchain
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/crypto-mlm-software-development"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Crypto MLM Software Development
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/smart-contract-development"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Smart Contract Development
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/crypto-wallet-development"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Crypto Wallet Development
                                                    </Link>
                                                    </li>
                                                    <li><Link
                                                        to="/services/crypto-currency-exchange-development"
                                                        onClick={() => {
                                                            closeMenu();
                                                            setTimeout(() => {
                                                                window.location.reload();
                                                            }, 0);
                                                        }}
                                                    >
                                                        Crypto Exchange Services
                                                    </Link>
                                                    </li>
                                                </ul>
                                            )}
                                        </li>
                                    </ul>
                                )}
                            </li>











                            <li>
                                {/* <Link to="/developing-with-ai" onClick={closeMenu}>Developing With AI </Link> */}
                                <Link
                                    to="/developing-with-ai"
                                    onClick={() => {
                                        closeMenu();
                                        setTimeout(() => {
                                            window.location.reload();
                                        }, 0);
                                    }}
                                >
                                    Developing With AI
                                </Link>
                            </li>
                            <li>
                                {/* <Link to="/animation" onClick={closeMenu}>Animation Design</Link> */}
                                <Link
                                    to="/animation"
                                    onClick={() => {
                                        closeMenu();
                                        setTimeout(() => {
                                            window.location.reload();
                                        }, 0);
                                    }}
                                >
                                    Animation Design
                                </Link>

                            </li>
                            <li>
                                {/* <Link to="/contact" onClick={closeMenu}>Contact Us</Link> */}
                                <Link
                                    to="/contact"
                                    onClick={() => {
                                        closeMenu();
                                        setTimeout(() => {
                                            window.location.reload();
                                        }, 0);
                                    }}
                                >
                                    Contact Us
                                </Link>

                            </li>

                        </ul>
                        <div className="linediv"></div>
                    </div>
                </div>
            </section>
        </div>
    );
};




export default MobileHeader;
